import { ROUTES } from '@shared/utils';
import type { BundleAssignationFailureReason } from '../../types';

type AssignationErrorConfig = {
  type: 'info' | 'warning';
  message: string;
  buttonText: string | undefined;
  buttonUrl: string | undefined;
};

const assignationErrorConfig = {
  PLAYER_NEVER_PURCHASED: {
    type: 'info',
    message: 'PLAYER_NEVER_PURCHASED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_DEPOSITED: {
    type: 'info',
    message: 'PLAYER_NEVER_DEPOSITED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_PURCHASED_AND_NEVER_DEPOSITED: {
    type: 'info',
    message: 'PLAYER_NEVER_PURCHASED_AND_NEVER_DEPOSITED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_PURCHASED_LOTTO: {
    type: 'info',
    message: 'PLAYER_NEVER_PURCHASED_LOTTO',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_PURCHASED_SCRATCHCARDS: {
    type: 'info',
    message: 'PLAYER_NEVER_PURCHASED_SCRATCHCARDS',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_PLAYED_GAMES: {
    type: 'info',
    message: 'PLAYER_NEVER_PLAYED_GAMES',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_BET_ON_SPORTSBOOK: {
    type: 'info',
    message: 'PLAYER_NEVER_BET_ON_SPORTSBOOK',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_STAKED_ON_GAMES: {
    type: 'info',
    message: 'PLAYER_NEVER_STAKED_ON_GAMES',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NEVER_STAKED_ON_ANY_PRODUCT: {
    type: 'info',
    message: 'PLAYER_NEVER_STAKED_ON_ANY_PRODUCT',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  BUNDLE_ALREADY_ASSIGNED: {
    type: 'info',
    message: 'BUNDLE_ALREADY_ASSIGNED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  BUNDLE_CAP_LIMIT_REACHED: {
    type: 'info',
    message: 'BUNDLE_CAP_LIMIT_REACHED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  BUNDLE_EXPIRED: {
    type: 'info',
    message: 'BUNDLE_EXPIRED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  BUNDLE_LOCKED_BY_PLATFORM: {
    type: 'info',
    message: 'BUNDLE_LOCKED_BY_PLATFORM',
    buttonText: undefined,
    buttonUrl: undefined,
  },
  BUNDLE_LOCKED_BY_INVALID_ACCOUNT: {
    type: 'warning',
    message: 'BUNDLE_LOCKED_BY_INVALID_ACCOUNT',
    buttonText: 'verification',
    buttonUrl: ROUTES.MY_ACCOUNT.ROOT,
  },
  BUNDLE_NOT_AVAILABLE_YET: {
    type: 'info',
    message: 'BUNDLE_NOT_AVAILABLE_YET',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  CURRENCY_MISMATCH: {
    type: 'warning',
    message: 'CURRENCY_MISMATCH',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  MAX_REFEREE_PER_REFERRER: {
    type: 'info',
    message: 'MAX_REFEREE_PER_REFERRER',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_NOT_QUALIFIED: {
    type: 'warning',
    message: 'PLAYER_NOT_QUALIFIED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  PLAYER_ASSIGNATION_NOT_FOUND: {
    type: 'info',
    message: 'PLAYER_ASSIGNATION_NOT_FOUND',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  RECURRENCE_NOT_ASSIGNABLE: {
    type: 'info',
    message: 'RECURRENCE_NOT_ASSIGNABLE',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  WRONG_REFERRAL: {
    type: 'info',
    message: 'WRONG_REFERRAL',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  RULE_NOT_PASSED: {
    type: 'info',
    message: 'RULE_NOT_PASSED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  BUNDLE_TARGET_MISMATCH: {
    type: 'info',
    message: 'BUNDLE_TARGET_MISMATCH',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  BUNDLE_TARGET_MISMATCH_NEW_PLAYERS: {
    type: 'info',
    message: 'BUNDLE_TARGET_MISMATCH_NEW_PLAYERS',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
  BUNDLE_TARGET_MISMATCH_NEW_PLAYERS_EXCLUDED: {
    type: 'info',
    message: 'BUNDLE_TARGET_MISMATCH_NEW_PLAYERS_EXCLUDED',
    buttonText: 'other_promotions',
    buttonUrl: ROUTES.OFFERS,
  },
} satisfies Record<BundleAssignationFailureReason, AssignationErrorConfig>;

export { assignationErrorConfig };
